export const stockClassKeys = {
  all: ['stock-class'] as const,
  FETCH_LIST: (corporationId: number) =>
    ['stock-class', 'list', corporationId] as const,
};
